export enum AceInvolvementTypeChangeReasonEnum {
  EXPANSION_OPPORTUNITY = 'Expansion Opportunity',
  CHANGE_IN_DEAL_INFORMATION = 'Change in Deal Information',
  CUSTOMER_REQUESTED = 'Customer Requested',
  TECHNICAL_COMPLEXITY = 'Technical Complexity',
  RISK_MITIGATION = 'Risk Mitigation',
}
